export default __webpack_public_path__ + "static/media/community.06ff7b72.svg";